import React from 'react';
import { Box } from '@mui/material';

import { ReactComponent as IconTeam } from '@assets/svg/team.svg';
import { ReactComponent as IconActive } from '@assets/svg/active.svg';
import { ReactComponent as IconPeople } from '@assets/svg/people.svg';
import { CommonCard } from '@organisms';

interface CardListProps {
  loading: boolean;
  accounts: number;
  users: number;
  actives: number;
}

const CardList: React.FC<CardListProps> = ({
  accounts,
  users,
  actives,
  loading
}: CardListProps) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
          gap: 2,
          gridAutoRows: '1fr'
        }}
      >
        <CommonCard
          title="Total Accounts"
          count={accounts}
          icon={<IconPeople />}
          accent="neutral"
          loading={loading}
        />
        <CommonCard
          title="Total Users"
          count={users}
          icon={<IconTeam />}
          accent="info"
          loading={loading}
        />
        <CommonCard
          title="Active Users"
          count={actives}
          icon={<IconActive />}
          accent="success"
          loading={loading}
        />
      </Box>
    </Box>
  );
};

export default CardList;
